import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { BaseResourceService, Compra } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class CompraService extends BaseResourceService<Compra> {

  constructor(
    protected injector: Injector
  ) {
    super(`compras`, injector);
  }

  public obterPorNumero(numero: number, ano: number, orgaoId: number): Observable<Compra> {
    return this.http.get<Compra>(`${this.login.cidade.id}/${this.api}/filtrar?numero=${numero}&exercicio.ano=${ano}&orgao_id=${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public proximoNumeroOF(exercicio: number, orgaoId: number): Observable<number> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/proximo-numero/${exercicio}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public buscaOfAlmoxarifado(exercicioId: number, orgaoId: number, numero: number, dt_movimento: Date, estoque_id: number) {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/busca-of-almoxarifado/${exercicioId}/${orgaoId}/${numero}/${dt_movimento}/${estoque_id}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public proximaDataCompra(exercicio: number, orgaoId: number): Observable<Date> {
    return this.http.get<Date>(
      `${this.login.cidade.id}/${this.api}/proxima-data/${exercicio}/${orgaoId}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public exportarCompra(compras: Compra[], exercicio: number, orgaoId: number): Observable<Compra[]> {
    return this.http.post<Compra[]>(
      `${this.login.cidade.id}/${this.api}/exportar-empenho/${exercicio}/${orgaoId}`, {compras},
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalizadores(exercicio: number, orgaoId: number, numero: number): Observable<any> {
    let parametros = '';
    parametros += '?exercicio_id=' + exercicio;
    parametros += '&orgao_id=' + orgaoId;
    parametros += '&numero=' + numero;
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/extendido/1/1${parametros}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public totalizadoresFicha(exercicio: number, orgaoId: number, fichaId: number, dataCompra: string): Observable<any> {
    return this.http.get<number>(
      `${this.login.cidade.id}/${this.api}/totalizadores-ficha/${exercicio}/${orgaoId}/${fichaId}/${dataCompra}`,
      this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
